export enum SliderOrientation {
  Horizontal,
  Vertical
}
